import React from "react";
import i18n from 'i18next'

class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: this.props.lang,
    };

  }
  handleChange(e) {
    this.setState({
      lang: e.target.value,
    })
  }
  render() {
    const msg = this.props.Message;
    return (
      <footer>
        <div className="container">
          <div className="grid-box">
            <div></div>
            <div className="copyright">&copy; {i18n.t(msg.copyright)}
            </div>
            <div className="terms-and-privacy">
              <a href="pdf/Hackathon_TermsConditions.pdf" target="_blank" rel="noopener noreferrer">{i18n.t(msg.termsAndCondition)}</a>
              <a href="pdf/Privacy_Policy.pdf" target="_blank" rel="noopener noreferrer">{i18n.t(msg.privacyPolicy)}</a>
            </div>
          </div>
        </div>
      </footer>

    );
  }
}

export default Footer;